import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { LandingComponent } from './landing/landing.component';
import { InfoComponent } from './landing/info/info.component';
import { UserOfferComponent } from './landing/info/user-offer/user-offer.component';
import { EulaComponent } from './landing/info/eula/eula.component';
import { BlogPagesComponent } from './landing/info/blog-pages/blog-pages.component';
import { ConfidentialComponent } from './landing/info/confidential/confidential.component';
import { ContactsComponent } from './landing/info/contacts/contacts.component';
import { InstructionsComponent } from './landing/info/instructions/instructions.component';
import { BlogComponent } from './landing/info/blog/blog.component';
import { WelcomePageComponent } from './landing/welcome-page/welcome-page.component';
import { UiComponent } from './ui/ui.component';

const routes: Routes = [
  {
    path: 'main', loadChildren: './core/core.module#CoreModule'
  },
  { path: 'auth', component: AuthComponent },
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  {
    path: '', component: LandingComponent,
    children: [
      {
        path: 'info', component: InfoComponent,
        children: [
          { path: 'useroffer', component: UserOfferComponent },
          { path: 'eula', component: EulaComponent },
          { path: 'confidential', component: ConfidentialComponent },
          { path: 'contacts', component: ContactsComponent },
          { path: 'instructions', component: InstructionsComponent },
          { path: 'instructions/:id', component: BlogPagesComponent},
          { path: 'blog', component: BlogComponent },
          { path: 'blog/:id', component: BlogPagesComponent},
          {
            path: '**',
            redirectTo: '/main/not-found',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'welcome', component: WelcomePageComponent
      }
    ]
  },
  { path: 'ui', component: UiComponent },
  {
    path: '**',
    redirectTo: '/main/not-found',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      { preloadingStrategy: PreloadAllModules }
      )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts